<template>
  <v-app>
   <v-container>
     <router-view></router-view>
    </v-container>
  </v-app>
</template>
<script>

import config from './app/config'
import './assets/stylus/app.styl'

export default {
  name: 'App',
  data: () => ({
    //
  }),
  mounted () {
    document.title = config.site.title
  }
}
</script>
